export { NextOfKinChatTab } from './NextOfKinChatTab';
export { PatientChatTab } from './PatientChatTab';
export { PatientVideoConsultTab } from './VideoConsultTab';
